import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import "@/App.css";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { FloatingWhatsApp, StickyMobileBar } from "@/components/Overlays";
import ChatWidget from "@/components/ChatWidget";
import BookingPopup from "@/components/BookingPopup";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import Fleet from "@/pages/Fleet";
import OneWay from "@/pages/OneWay";
import AllRajasthan from "@/pages/AllRajasthan";
import Tours from "@/pages/Tours";
import Gallery from "@/pages/Gallery";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Faq from "@/pages/Faq";
import CityPage from "@/pages/CityPage";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import { Outstation, AirportTaxi, LocalJodhpur } from "@/pages/ServicePages";
import NotFound from "@/pages/NotFound";
import Admin from "@/pages/Admin";
import { CITIES } from "@/data/content";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => window.scrollTo({ top: 0, behavior: "instant" }), [pathname]);
  return null;
}

function HomePopup() {
  const { pathname } = useLocation();
  return pathname === "/" ? <BookingPopup /> : null;
}

function App() {
  useEffect(() => {
    let lenis = null;
    let id;
    try {
      lenis = new Lenis({ lerp: 0.11, smoothWheel: true });
      const raf = (t) => { if (lenis) lenis.raf(t); id = requestAnimationFrame(raf); };
      id = requestAnimationFrame(raf);
    } catch (e) {
      console.warn("Smooth scroll unavailable:", e);
    }
    return () => {
      if (id) cancelAnimationFrame(id);
      try {
        if (lenis && typeof lenis.destroy === "function") lenis.destroy();
      } catch {}
      lenis = null;
    };
  }, []);

  return (
    <BrowserRouter>
      <ScrollToTop />
      <div className="min-h-screen flex flex-col pb-[52px] md:pb-0">
        <Header />
        <main className="grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<Services />} />
            <Route path="/fleet" element={<Fleet />} />
            <Route path="/one-way-taxi" element={<OneWay />} />
            <Route path="/all-rajasthan-taxi" element={<AllRajasthan />} />
            <Route path="/outstation-taxi" element={<Outstation />} />
            <Route path="/airport-taxi" element={<AirportTaxi />} />
            <Route path="/local-jodhpur-taxi" element={<LocalJodhpur />} />
            <Route path="/tour-packages" element={<Tours />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/faq" element={<Faq />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            {CITIES.map((c) => (
              <Route key={c.slug} path={`/taxi-service-${c.slug}`} element={<CityPage slug={c.slug} />} />
            ))}
            <Route path="/admin" element={<Admin />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        <Footer />
      </div>
      <FloatingWhatsApp />
      <StickyMobileBar />
      <ChatWidget />
      <HomePopup />
      <Toaster position="top-center" richColors />
    </BrowserRouter>
  );
}

export default App;
